import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import StorySection from "@/components/about/StorySection";
import ValuesSection from "@/components/about/ValuesSection";
import ShowroomsSection from "@/components/about/ShowroomsSection";
import CTASection from "@/components/about/CTASection";

const About = () => {
  return (
    <Layout>
      <PageHero
        title="About Us"
        subtitle="Charlotte's premier flooring company. All materials and installation for one low price."
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "About Us" },
        ]}
      />
      <StorySection />
      <ValuesSection />
      <ShowroomsSection />
      <CTASection />
    </Layout>
  );
};

export default About;
